let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6uGrd")).then(() => parcelRequire('3Um2C'));